import { Component, Inject, Vue } from 'vue-property-decorator';
import ResetAccountServiceComponent from '@/account/reset-service/reset-account-service.vue';
import UserMyPageService from '@/service/userMyPage.service';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({
  computed: {},
  methods: {},
  components: {
    resetAccountServiceComponent: ResetAccountServiceComponent,
  },
})
export default class MyPageReset extends Vue {
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;

  @appStoreState.Getter
  getIsOpenResetServiceModal!: boolean;

  @appStoreState.Mutation
  public setIsOpenResetServiceModal!: (payload: any) => void;

  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  waitingResetApi = false;
  resetAccount() {
    this.setIsOpenResetServiceModal(true);
  }

  async deleteMoreData(userIdInput: string) {
    if (userIdInput) {
      try {
        const res = await this.userMyPageService().callApiDeleteMoreData(userIdInput);

        return res && res?.status === 200;
      } catch (e) {
        return false;
      }
    }
  }

  async reloadAndNavigate() {
    try {
      await this.$router.push('/home');
      window.location.reload();
    } catch (error) {
      console.error('Failed to navigate:', error);
    }
  }

  async resetService() {
    if (this.localStorageUser?.id) {
      try {
        this.waitingResetApi = true;
        const res = await this.userMyPageService().callApiResetService(this.localStorageUser?.id);

        if (res.status === 200) {
          const isDoneDeleteMoreData = await this.deleteMoreData(this.localStorageUser?.id);
          if (isDoneDeleteMoreData) {
            this.reloadAndNavigate();
          } else {
            this.showResponseMessage(`${this.$t('toast.reset.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
          }
        } else {
          this.showResponseMessage(`${this.$t('toast.reset.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
        }
      } catch (e) {
        this.showResponseMessage(`${this.$t('toast.reset.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
      } finally {
        this.waitingResetApi = false;
        this.setIsOpenResetServiceModal(false);
      }
    }
  }

  back() {
    this.$router.push('/my-page/detail');
  }

  showResponseMessage(mess, title, variant, hideDelay) {
    this.$bvToast.toast(mess, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: hideDelay,
    });
  }
}
